export default __webpack_public_path__ + "assets/images/ee29aa42c12f417b9d1f1ef48d35d1c4.svg";